export default __webpack_public_path__ + "static/media/line-h-02.2a7319b7.png";